import { useEffect, useRef, useState } from "react";
import { http, formatApiError } from "@/lib/api";

export const useGame = (kind, req, lesson) => {
  const [g, setG] = useState(null);
  const [err, setErr] = useState("");
  const reqId = useRef(0);
  const load = () => {
    const id = ++reqId.current;
    setErr(""); setG(null);
    http.post("/journal/game", { kind, subject_id: req.subject_id, topic: req.topic, grade: req.grade, lesson: (lesson || "").slice(0, 6000) })
      .then((r) => id === reqId.current && setG(r.data)).catch((e) => id === reqId.current && setErr(formatApiError(e)));
  };
  useEffect(() => { load(); return () => { reqId.current += 1; }; }, [kind]); // eslint-disable-line react-hooks/exhaustive-deps
  return { g, err, load };
};
